__turbopack_context__.v({
  "keyword": "BlogLatest-module-scss-module__wMjcgW__keyword",
  "keywords": "BlogLatest-module-scss-module__wMjcgW__keywords",
  "post_body": "BlogLatest-module-scss-module__wMjcgW__post_body",
  "post_card": "BlogLatest-module-scss-module__wMjcgW__post_card",
  "post_category": "BlogLatest-module-scss-module__wMjcgW__post_category",
  "post_description": "BlogLatest-module-scss-module__wMjcgW__post_description",
  "post_image": "BlogLatest-module-scss-module__wMjcgW__post_image",
  "post_image_placeholder": "BlogLatest-module-scss-module__wMjcgW__post_image_placeholder",
  "post_title": "BlogLatest-module-scss-module__wMjcgW__post_title",
  "post_title_compact": "BlogLatest-module-scss-module__wMjcgW__post_title_compact",
});
